export default __webpack_public_path__ + "static/product-unit-8-dining-98bcdddca24b44c41e0acf1acb466193.png";